import React, { Component, PropTypes } from 'react';
import { mixin, RefluxMixin } from 'Util';
import { KlarnaStore, StoreOverviewStore, AuthStore } from 'stores';
import KlarnaOnlineForm from 'components/Store/KlarnaOnlineForm';
import { getCart } from 'selectors/store';

class KlarnaOnlineFormContainer extends mixin(RefluxMixin, Component) {
  listenToStores() {
    this.listenToStoreWithMapper(KlarnaStore, state => ({
      ...state
    }));
    this.listenToStoreWithMapper(AuthStore, state => ({
      loggedIn: state.loggedIn
    }));

    this.listenToStoreWithMapper(StoreOverviewStore, state => ({
      cart: getCart(state),
      method: state.payment.method,
      paymentLoading: state.payment.loading
    }));
  }

  render() {
    return <KlarnaOnlineForm {...this.state} {...this.props} />;
  }
}

export default KlarnaOnlineFormContainer;



// WEBPACK FOOTER //
// ./src/js/containers/Store/KlarnaOnlineForm.js